<template>
  <v-chip variant="flat" size="small" v-for="man_id in filters.manufacturers" :color="ConfigElementsColor" class="mr-1 mb-2" @click="RemoveFilter('manufacturers',+man_id)">{{ GetBrandName(man_id) }} &times;  </v-chip>
  <v-chip variant="flat" size="small" v-for="device in filters.device_types"  :color="ConfigElementsColor" class="mr-1 mb-2" @click="RemoveFilter('device_types',device)">{{ device }} &times;  </v-chip>
  <v-chip variant="flat" size="small" v-for="colors in filters.copier_colors" :color="ConfigElementsColor" class="mr-1 mb-2" @click="RemoveFilter('copier_colors',colors)">{{ colors }} &times;  </v-chip>
  <v-chip variant="flat" size="small" v-for="price  in filters.price_filters" :color="ConfigElementsColor" class="mr-1 mb-2" @click="RemovePriceFilter(price)">{{ price.label }} &times;  </v-chip>

  <!-- New Filters-->
  <v-chip variant="flat" size="small" v-for="ppsize in filters.paper_sizes" :color="ConfigElementsColor" class="mr-1 mb-2" @click="RemoveFilter('paper_sizes',ppsize)">{{ ppsize }} &times;  </v-chip>
  <v-chip variant="flat" size="small" v-for="categories in filters.product_categories" :color="ConfigElementsColor" class="mr-1 mb-2" @click="RemoveFilter('product_categories',categories)">{{ categories }} &times;  </v-chip>
  <v-chip variant="flat" size="small" v-for="form_factor in filters.form_factors" :color="ConfigElementsColor" class="mr-1 mb-2" @click="RemoveFilter('form_factors',form_factor)">{{ form_factor }} &times;  </v-chip>
  <v-chip variant="flat" size="small" v-for="capability in filters.capabilities" :color="ConfigElementsColor" class="mr-1 mb-2" @click="RemoveFilter('capabilities',capability)">{{ capability }} &times;  </v-chip>
  <v-chip variant="flat" size="small" v-for="connection in filters.connection_types" :color="ConfigElementsColor" class="mr-1 mb-2" @click="RemoveFilter('connection_types',connection)">{{ connection }} &times;  </v-chip>
  <v-chip variant="flat" size="small" v-for="usage_level in filters.usage_levels" :color="ConfigElementsColor" class="mr-1 mb-2" @click="RemoveFilter('usage_levels',usage_level)">{{ usage_level }} &times;  </v-chip>
  <v-chip
    size="small"
    variant="flat"
    class="mr-1 mb-2"
    :color="ConfigElementsColor"
    v-for="size in filters.office_sizes"
    @click="RemoveFilter('office_sizes', size)">
    {{ GetOfficeSizeLabel(size) }} &times;
  </v-chip>
  <v-chip
    size="small"
    variant="flat"
    class="mr-1 mb-2"
    :color="ConfigElementsColor"
    v-for="vol in filters.print_volumes"
    @click="RemoveFilter('print_volumes', vol)">
    {{ GetPrintVolumeLabel(vol) }} &times;
  </v-chip>

  <v-chip variant="flat" size="small" v-if="filters.sort_type" class="info mr-1 mb-2 text-capitalize" :color="ConfigElementsColor" @click="RemoveSorter">
    {{ GetSortName(filters.sort_type) }} &times;
  </v-chip>
  <template v-if="filters.active_speed && filters.speed_maximum && filters.speed_minimum">
    <v-chip variant="flat" size="small" :color="ConfigElementsColor" class="mr-1 mb-2" @click="RemoveSpeedFilter">
      <span class="text-capitalize">{{ filters.active_speed }}</span>&nbsp;Speed:
      {{ filters.speed_minimum }}-{{ filters.speed_maximum }} PPM &times;
    </v-chip>
  </template>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

const store = useGlobalsStore()
const { filters, manufacturers, sort_types, ConfigElementsColor } = storeToRefs(store)

function RemoveFilter(target: string, value: any) {
  const filtersCopy = { ...filters.value } as any
  const index = filtersCopy[target].indexOf(value)
  if (index !== -1) {
    filtersCopy[target].splice(index, 1)
    store.SetFilters(filtersCopy)
  }
}

function RemoveSorter() {
  store.SetFilters({
    ...filters.value,
    sort_type: null
  })
}

function RemoveSpeedFilter() {
  store.SetFilters({
    ...filters.value,
    active_speed: null,
    speed_minimum: null,
    speed_maximum: null
  } as any)
}

function GetBrandName(man_id: number | string) {
  const brand = manufacturers.value.find(man => man.id == man_id)
  return brand === undefined ? '' : brand.name
}

function RemovePriceFilter(min_max: { min: number; max: number }) {
  const currentPriceFilters = [...filters.value.price_filters]
  const index = currentPriceFilters.findIndex(
    filter => filter.min === min_max.min && filter.max === min_max.max
  )
  if (index !== -1) {
    currentPriceFilters.splice(index, 1)
    store.SetFilters({
      ...filters.value,
      price_filters: currentPriceFilters
    })
  }
}

function GetSortName(value: string | null) {
  const sortItem = sort_types.value.find(s => s.value == value)
  return sortItem ? sortItem.title : ''
}

function GetOfficeSizeLabel(val: string): string {
  const labels: Record<string, string> = {
    '1-10': '1–10 people',
    '10-25': '10–25 people',
    '25-50': '25–50 people',
    '50+': '50+ people',
  }
  return labels[val] || val
}

function GetPrintVolumeLabel(val: string): string {
  const labels: Record<string, string> = {
    '<3000': '< 3,000 prints/mo',
    '3000-10000': '3,000–10,000 prints/mo',
    '10000+': '10,000+ prints/mo',
  }
  return labels[val] || val
}
</script>
